import React from 'react';
import './radio.css';
const Radio = ({ heading, selected,id,onChange,}) => (
  <>
    <div className="md-radio">
      <input id={id} type="radio" name="g" checked={heading === selected}   onChange={onChange}/>
      <label htmlFor={id}>{heading}</label>
    </div>
  </>
)
export default Radio;